import cn from 'classnames';
import React from 'react';
import styles from './icon.module.scss';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
}

const Icon: React.FC<IconProps> = ({ name, size, color }) => {
  const style: React.CSSProperties = {
    fontSize: size ? `${size}px` : '20px'
  };

  if (color) {
    style.color = color;
  }

  return (
    <span
      className={cn(name, styles.root, {
        [styles.customColor]: color
      })}
      style={style}
    />
  );
};

export default Icon;
